import { useState } from "react";
import { Check, Clock, MapPin, Pencil, X } from "lucide-react";
import { toast } from "sonner";
import { errText, papi } from "./portalApi";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

/* Tracking number (opens Ship24 and stamps "last checked") + the partner's pasted last position of the parcel. */
export const TrackCell = ({ g }) => {
  const [n, setN] = useState(g.track_note || {});
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState("");
  if (!g.tracking) return null;
  const t = encodeURIComponent(g.tracking.trim());
  const checked = () => papi("post", `/track-notes/${t}/checked`).then(setN).catch(() => {});
  const save = async () => {
    try { setN(await papi("put", `/track-notes/${t}`, { position: v })); setEdit(false); toast.success("Last position saved"); }
    catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="space-y-0.5">
      <a href={`https://www.ship24.com/tracking?p=${g.tracking}`} target="_blank" rel="noreferrer" onClick={checked}
        className="font-mono font-semibold text-teal-700 underline" data-testid={`portal-parcel-track-${g.key}`}>{g.tracking}</a>
      {n.checked_at && <div className="flex items-center gap-1 text-[10px] text-slate-500" data-testid={`portal-track-checked-${g.key}`}><Clock className="h-3 w-3" />Checked {when(n.checked_at)}</div>}
      {edit ? (
        <div className="flex items-center gap-1">
          <input autoFocus value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEdit(false); }}
            maxLength={300} placeholder="Paste last position…" className="h-7 w-44 rounded border px-2 text-[11px]" data-testid={`portal-track-pos-input-${g.key}`} />
          <button onClick={save} className="rounded bg-teal-700 p-1 text-white" data-testid={`portal-track-pos-save-${g.key}`}><Check className="h-3 w-3" /></button>
          <button onClick={() => setEdit(false)} className="rounded border p-1 text-slate-500"><X className="h-3 w-3" /></button>
        </div>
      ) : n.position ? (
        <button onClick={() => { setV(n.position); setEdit(true); }} title={`Saved ${when(n.position_at)} — click to change`}
          className="flex max-w-[200px] items-start gap-1 whitespace-normal rounded bg-sky-50 px-1.5 py-0.5 text-left text-[11px] text-sky-900" data-testid={`portal-track-pos-${g.key}`}>
          <MapPin className="mt-0.5 h-3 w-3 shrink-0 text-sky-600" /><span>{n.position}<span className="block text-[10px] text-sky-600">{when(n.position_at)}</span></span>
          <Pencil className="mt-0.5 h-2.5 w-2.5 shrink-0 text-sky-500" /></button>
      ) : (
        <button onClick={() => { setV(""); setEdit(true); }} className="inline-flex items-center gap-1 text-[11px] text-sky-700 hover:underline" data-testid={`portal-track-pos-add-${g.key}`}>
          <MapPin className="h-3 w-3" />Add last position</button>
      )}
    </div>
  );
};
